<template>
    <v-form ref="form" @submit.prevent="resetpassword">
        <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-green">
                        <div class="card-icon">
                            <md-icon>key</md-icon>
                        </div>
                        <h4 class="title">更改密码</h4>
                    </md-card-header>
                    <md-card-content>
                    <v-text-field v-model="user.password" label="请正确输入原密码" name="password" prepend-icon="mdi-lock" type="password" :rules="rules.passwordRules" />
                    <v-text-field v-model="password" label="新密码" name="password" prepend-icon="mdi-lock" type="password" :rules="rules.passwordRules" />
                    <v-text-field v-model="repassword" label="确认新密码" name="confirmPassword" prepend-icon="mdi-lock" type="password" :rules="rules.confirmPasswordRules" />
                    </md-card-content>
                    <md-card-actions md-alignment="right">
                        <md-button class="md-success" type="submit">确 定</md-button>
                    </md-card-actions>
                </md-card>
            </div>
        </div>
    </v-form>
</template>
<script>
import kit from '/common/js/kit.js';
import { SlideYDownTransition } from 'vue2-transitions'
import { resetpassword, userInfo } from '@/api/user';

export default {
    components: {
        SlideYDownTransition,
    },
    data() {
        return {
            uid: '',
            password: '',
            repassword: '',
            file: '',
            active: false,
            user: Object,
            rules: {
                passwordRules: [
                    (value) => !!value || '请输入密码.',
                    // (value) => (value && value.length >= 6) || '最少6个字符',
                ],
                confirmPasswordRules: [
                    (value) => !!value || '请输入确认密码',
                    (value) =>
                    value === this.password || '新密码与确认密码不一致.',
                ],
            }
        };
    },
    created() {
        this.uid = this.$route.query.uid || '';
        this.userInfo();
    },
    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit("on-validated", true);
                return true;
            }
        },
        getUser() {
            return this.user;
        },
        userInfo() {
            let tempData = {
                uid: this.uid
            }
            userInfo(tempData).then((res) => {
                if (res.code == '200') {
                    this.user = { ...this.user, ...res.data };
                    kit.setUserInfo(this.user);
                }
            })
        },
        resetpassword() {
            let tempData = {
                oldpassword: this.user.password,
                password: this.password,
                repassword: this.repassword,
                uid: this.user.uid
            }
            resetpassword(tempData).then((res) => {
                if (res.code === '200') {
                    this.$notify({
                        timeout: 1500,
                        message: '修改成功！',
                        icon: 'add_alert',
                        horizontalAlign: 'center',
                        verticalAlign: 'bottom',
                        type: 'success'
                    })
                    this.active = false;
                    if (this.uid) return;
                    this.userInfo();
                }
            })
        }
    },
};
</script>